import { GetStaticProps } from 'next';
import AboutPage from '../../components/elements/AboutPage';
import { Card } from '../../components/ui/TabBox';
import { ABOUT_PAGE } from '../../queries/about';
import { AcademyAboutUs } from '../../types/schema';
import { initializeApollo } from '../../utils/apollo';
import rollbar from '../../utils/rollbar';

const sobre: React.FC<{ aboutPage: AcademyAboutUs }> = ({ aboutPage }) => {
  const metaImageUrl = (aboutPage.metadata?.metaImage as { url?: string })?.url || '';
  const bannerImageUrl = (aboutPage.bannerImg as { url?: string })?.url || '';
  const imageUrl = (aboutPage.image as { url?: string })?.url || '';

  return (
    <AboutPage
      metaTitle={aboutPage.metadata?.metaTitle as string}
      metaDescription={aboutPage.metadata?.metaDescription as string}
      metaImage={metaImageUrl}
      bannerImg={bannerImageUrl}
      bannerTitle={aboutPage.bannerTitle as string}
      title={aboutPage.title as string}
      description={aboutPage.description as string}
      valuesDescription={aboutPage.valuesDescription as string}
      image={imageUrl}
      cards={aboutPage.cards as Card[]}
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo();

  try {
    const { data } = await apolloClient.query({
      query: ABOUT_PAGE,
    });

    return {
      props: {
        aboutPage: data.academyAboutUs,
      },
      revalidate: 60,
    };
  } catch (error) {
    rollbar.error('Error fetching about page', { error });
    return {
      notFound: true,
    };
  }
};

export default sobre;
